import React, { useEffect, useState } from "react";

const emptyForm = {
  title: "",
  date: "",
  message: "",
  flyerFile: null,
};

export default function AnnouncementUploadForm({
  onSaveAnnouncement,
  isAdmin,
  editingAnnouncement = null,
}) {
  const [formData, setFormData] = useState(emptyForm);

  useEffect(() => {
    if (editingAnnouncement) {
      setFormData({
        title: editingAnnouncement.title || "",
        date: editingAnnouncement.date || "",
        message: editingAnnouncement.message || "",
        flyerFile: null,
      });
    } else {
      setFormData(emptyForm);
    }
  }, [editingAnnouncement]);

  function handleChange(event) {
    const { name, value, files, type } = event.target;

    if (type === "file") {
      setFormData((prev) => ({
        ...prev,
        [name]: files && files[0] ? files[0] : null,
      }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const payload = new FormData();
    payload.append("title", formData.title);
    payload.append("date", formData.date);
    payload.append("message", formData.message);

    if (formData.flyerFile) {
      payload.append("flyerFile", formData.flyerFile);
    }

    await onSaveAnnouncement(payload);

    if (!editingAnnouncement) {
      setFormData(emptyForm);
      event.target.reset();
    }
  }

  if (!isAdmin) return null;

  return (
    <div className="form-card">
      <h3>{editingAnnouncement ? "Edit Announcement" : "Add Announcement"}</h3>

      <form className="form-grid" onSubmit={handleSubmit}>
        <div>
          <label className="label" htmlFor="ann-title">Announcement Title</label>
          <input
            className="input"
            id="ann-title"
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Title"
            required
          />
        </div>

        <div>
          <label className="label" htmlFor="ann-date">Announcement Date</label>
          <input
            className="input"
            id="ann-date"
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label className="label" htmlFor="ann-message">Message</label>
          <textarea
            className="textarea"
            id="ann-message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Here's a quick update...(click to start typing)"
            required
          />
        </div>

        <div>
          <label className="label" htmlFor="ann-flyer">
            {editingAnnouncement ? "Replace Flyer (optional)" : "Flyer Attachment (optional)"}
          </label>
          <input
            className="input"
            id="ann-flyer"
            type="file"
            name="flyerFile"
            accept=".jpg,.jpeg,.png,.pdf"
            onChange={handleChange}
          />
          {editingAnnouncement?.flyerPath && !formData.flyerFile && (
            <p className="help-text">Current flyer will be kept unless a new one is uploaded.</p>
          )}
        </div>

        <button className="btn btn-primary" type="submit">
          {editingAnnouncement ? "Update Announcement" : "Publish Announcement"}
        </button>
      </form>
    </div>
  );
}
